import React from 'react';
import { ExperimentsContext } from './ExperimentsContext';
import { useReadyExperiments } from './useReadyExperiments';
export var PureExperimentsProvider = function (_a) {
    var experiments = _a.experiments, children = _a.children;
    var value = useReadyExperiments(experiments);
    return (React.createElement(ExperimentsContext.Provider, { value: value }, children));
};
//# sourceMappingURL=PureExperimentsProvider.js.map